import { getActiveRestaurantId } from "../utils/activeRestaurant";
import { useEffect, useState } from "react";
import { ILoginInfo } from "../models/ILoginInfo";
import { decrypt } from "../utils/Util";
import { PromoCodesContent } from "../components/PromoCodesContent";

export default function PromoCodesPage() {
  const [restaurantId, setRestaurantId] = useState("");

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      const u: ILoginInfo = JSON.parse(decrypt(userJson));
      setRestaurantId(getActiveRestaurantId());
    }
  }, []);

  if (!restaurantId) return null;
  return <PromoCodesContent restaurantId={restaurantId} />;
}
